<app-two-panel>
  <div class="first">
    <app-input-textarea placeHolder="Timestamp to be converted from UTC to PST" (inputData)="onInputChanged($event)"></app-input-textarea>
  </div>
  <div class="second">
    <p *ngFor="let data of outputData">
      {{ data }}
    </p>
    <button mat-raised-button color="accent" *ngIf="outputData.length > 0" (click)="outputData=[]">clear</button>
  </div>
</app-two-panel>

